import { render, staticRenderFns } from "./ModalOverlay.vue?vue&type=template&id=564b2c17"
import script from "./ModalOverlay.vue?vue&type=script&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports